import { render, staticRenderFns } from "./EditorBlockBoolean.vue?vue&type=template&id=2148a6da&scoped=true"
import script from "./EditorBlockBoolean.vue?vue&type=script&lang=js"
export * from "./EditorBlockBoolean.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockBoolean.vue?vue&type=style&index=0&id=2148a6da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148a6da",
  null
  
)

export default component.exports